import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import LightGestion from 'components/headers/lightGestion';
import { useTranslation } from 'react-i18next';
// import i18n from '../../i18n';

const TabButton = ({ active, onClick, children }) => (
  <button
    className={`btn ${active ? 'btn-primary' : 'btn-outline-secondary'}`}
    onClick={onClick}
    style={{ borderRadius: 10 }}
  >
    {children}
  </button>
);

const Card = ({ title, icon, children }) => (
  <div style={{ background: 'var(--card-bg)', border: '1px solid var(--border)', borderRadius: 16, padding: 16, boxShadow: '0 2px 8px rgba(15,23,42,0.06)' }}>
    <div className="d-flex align-items-center gap-2 mb-2">
      <div style={{ width: 36, height: 36, borderRadius: 10, background: '#eef2ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</div>
      <h4 className="m-0" style={{ fontWeight: 800 }}>{title}</h4>
    </div>
    {children}
  </div>
);

const load = (k, def) => {
  try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : def; } catch { return def; }
};
const save = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} };

const Parametres = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState('societe'); // societe | (apparence/securite/utilisateurs if enabled later)

  const [company, setCompany] = useState(load('company.info', {
    name: '', phone: '', email: '', ice: '', website: '', address: '', logo: '', rc: '', if: '', tp: ''
  }));
  const [logoFile, setLogoFile] = useState(null);
  const [saving, setSaving] = useState(false);

  // Theme and language management removed on this screen to focus on Société info only.

  const onLogoChange = async (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      setCompany(c => ({ ...c, logo: reader.result }));
      setLogoFile(file);
    };
    reader.readAsDataURL(file);
  };
useEffect(() => {
  const fetchCompany = async () => {
    try {
      const token = localStorage.getItem('authToken');

      const res = await axios.get(
        'https://plateformewmg.cloud/api/Gestion/societes',
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : ''
          }
        }
      );

      if (res.data.data.length > 0) {
        const s = res.data.data[0]; // take first company
        setCompany({
          name: s.Nom || '',
          phone: s.Telephone || '',
          email: s.Email || '',
          ice: s.ICE || '',
          website: s.SiteWeb || '',
          address: s.Address || '',
          rc: s.RC || '',
          if: s.IF || '',
          tp: s.TP || '',
          logo: s.logo_url || ''
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  fetchCompany();
}, []);


  return (
    <AnimationRevealPage>
      <LightGestion />

      <div className="container  app-content" style={{ maxWidth: 1100 ,marginTop:"-60px",marginLeft:"-20px"}}>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="d-flex align-items-center gap-2">
            <div style={{ width: 44, height: 44, borderRadius: 12, background: '#eef2ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>⚙️</div>
            <div>
              <div style={{ fontWeight: 900, fontSize: '30px', marginBottom: 6 }}>{t('settings.title','Paramètres')}</div>
              <div style={{ color: '#6b7280' }}>{t('settings.subtitle','Configurez votre application selon vos préférences')}</div>
            </div>
          </div>
        </div>

        <div className="d-flex gap-2 mb-3">
          <TabButton active={tab === 'societe'} onClick={() => setTab('societe')}>{t('settings.tabs.company','Société')}</TabButton>
        </div>

        

        {tab === 'societe' && (
          <Card title={t('settings.company.title','Informations de la Société')} icon={<span>🏢</span>}>
            <div className="row g-3">
              <div className="col-md-12">
                <label className="form-label">{t('settings.company.labels.name','Nom de la société')}</label>
                <input className="form-control" value={company.name} onChange={(e) => setCompany(c => ({ ...c, name: e.target.value }))} placeholder={t('settings.company.placeholders.name','Entrez le nom de votre société')} />
              </div>
              <div className="col-md-6">
                <label className="form-label">{t('settings.company.labels.phone','Téléphone')}</label>
                <input className="form-control" value={company.phone} onChange={(e) => setCompany(c => ({ ...c, phone: e.target.value }))} placeholder={t('settings.company.placeholders.phone','+212 6XX XXX XXX')} />
              </div>
              <div className="col-md-6">
                <label className="form-label">{t('settings.company.labels.email','Email')}</label>
                <input className="form-control" type="email" value={company.email} onChange={(e) => setCompany(c => ({ ...c, email: e.target.value }))} placeholder={t('settings.company.placeholders.email','contact@entreprise.com')} />
              </div>
              <div className="col-md-6">
                <label className="form-label">{t("settings.company.labels.ice","ICE (Identifiant Commun de l'Entreprise)")}</label>
                <input className="form-control" value={company.ice} onChange={(e) => setCompany(c => ({ ...c, ice: e.target.value }))} placeholder={t('settings.company.placeholders.ice','000000000000000')} />
              </div>
              <div className="col-md-6">
                <label className="form-label">{t('settings.company.labels.rc','RC')}</label>
                <input className="form-control" value={company.rc} onChange={(e) => setCompany(c => ({ ...c, rc: e.target.value }))} placeholder={t('settings.company.placeholders.rc','Registre de commerce')} />
              </div>
              <div className="col-md-6">
                <label className="form-label">{t('settings.company.labels.website','Site Web')}</label>
                <input className="form-control" value={company.website} onChange={(e) => setCompany(c => ({ ...c, website: e.target.value }))} placeholder={t('settings.company.placeholders.website','https://www.entreprise.com')} />
              </div>
              <div className="col-md-12">
                <label className="form-label">{t('settings.company.labels.address','Adresse')}</label>
                <input className="form-control" value={company.address} onChange={(e) => setCompany(c => ({ ...c, address: e.target.value }))} placeholder={t('settings.company.placeholders.address','Adresse complète de votre société')} />
              </div>
              <div className="col-md-6">
                <label className="form-label">{t('settings.company.labels.if','IF')}</label>
                <input className="form-control" value={company.if} onChange={(e) => setCompany(c => ({ ...c, if: e.target.value }))} placeholder={t('settings.company.placeholders.if','Identifiant Fiscal')} />
              </div>
              <div className="col-md-6">
                <label className="form-label">{t('settings.company.labels.tp','TP')}</label>
                <input className="form-control" value={company.tp} onChange={(e) => setCompany(c => ({ ...c, tp: e.target.value }))} placeholder={t('settings.company.placeholders.tp','Patente (Taxe Professionnelle)')} />
              </div>
              <div className="col-md-12">
                <label className="form-label">{t('settings.company.labels.logo','Logo de la société')}</label>
                <input className="form-control" type="file" accept="image/*" onChange={(e) => onLogoChange(e.target.files?.[0])} />
                {company.logo && (
                  <div className="mt-2">
                    <img src={company.logo} alt="Logo" style={{ maxHeight: 72 }} />
                  </div>
                )}
              </div>
              <div className="col-12 d-flex justify-content-end mt-2" style={{ gap: 8 }}>
                <button
                  className="btn btn-primary"
                  disabled={saving || !company.name?.trim()}
                  onClick={async () => {
                    try {
                      setSaving(true);
                      // Build payload according to backend expected keys.
                      const token = localStorage.getItem('authToken');
                      const form = new FormData();
                      form.append('Nom', company.name || '');
                      form.append('Telephone', company.phone || '');
                      form.append('Address', company.address || '');
                      form.append('SiteWeb', company.website || '');
                      form.append('Email', company.email || '');
                      form.append('RC', company.rc || '');
                      form.append('ICE', company.ice || '');
                      form.append('IF', company.if || '');
                      form.append('TP', company.tp || '');

                      // Prefer real file upload if available; fallback to base64 -> Blob
                      const dataUrlToBlob = (dataUrl) => {
                        try {
                          const arr = dataUrl.split(',');
                          const mime = arr[0].match(/:(.*?);/)[1];
                          const bstr = atob(arr[1]);
                          let n = bstr.length; const u8arr = new Uint8Array(n);
                          while (n--) u8arr[n] = bstr.charCodeAt(n);
                          return new Blob([u8arr], { type: mime || 'image/png' });
                        } catch { return null; }
                      };

                      if (logoFile) {
                        form.append('logo', logoFile);
                      } else if (company.logo && String(company.logo).startsWith('data:')) {
                        const blob = dataUrlToBlob(company.logo);
                        if (blob) form.append('logo', new File([blob], 'logo.png', { type: blob.type }));
                      }

                      await axios.post('https://plateformewmg.cloud/api/Gestion/societes', form, {
                        headers: {
                          Authorization: token ? `Bearer ${token}` : '',
                          'Content-Type': 'multipart/form-data'
                        }
                      });
                      Swal.fire(t('settings.alerts.successTitle','Succès'), t('settings.alerts.successMessage','Informations de la société enregistrées.'), 'success');
                    } catch (err) {
                      const msg = err?.response?.data?.message || err?.message || t('settings.alerts.unknownError','Erreur inconnue');
                      Swal.fire(t('settings.alerts.errorTitle','Erreur'), String(msg), 'error');
                    } finally {
                      setSaving(false);
                    }
                  }}
                >
                  {saving ? t('settings.buttons.saving','Enregistrement...') : t('settings.buttons.save','Enregistrer')}
                </button>
              </div>
            </div>
          </Card>
        )}

        {tab === 'securite' && (
          <Card title={t('settings.security.title','Sécurité')} icon={<span>🔒</span>}>
            <div className="text-muted">{t('settings.security.upcoming','Paramètres de sécurité à venir (réinitialisation du mot de passe, 2FA, etc.).')}</div>
          </Card>
        )}

        {tab === 'utilisateurs' && (
          <Card title={t('settings.users.title','Utilisateurs')} icon={<span>👥</span>}>
            <div className="text-muted">{t('settings.users.upcoming','Gestion des utilisateurs à venir.')}</div>
          </Card>
        )}
      </div>

    </AnimationRevealPage>
  );
};

export default Parametres;
